import { createReducer } from 'redux-act';
import { PURGE } from 'redux-persist';

import {
    subjectUpdate,
    subjectAbbreviationUpdate,
    colorUpdate,
    teacherUpdate,
    teacherAbbreviationUpdate,
    newUserSubjectLoad,
    newUserSubjectClear
} from 'actions/new-usersubject';

const defaultState = {
    subject: '',
    subject_abbreviation: '',
    color: '',
    teacher: '',
    teacher_abbreviation: ''
};

const newUserSubject = createReducer({
    [subjectUpdate]: (state, payload) => ({
        ...state,
        subject: payload.subject
    }),
    [subjectAbbreviationUpdate]: (state, payload) => ({
        ...state,
        subject_abbreviation: payload.abbreviation
    }),
    [colorUpdate]: (state, payload) => ({
        ...state,
        color: payload.color
    }),
    [teacherUpdate]: (state, payload) => ({
        ...state,
        teacher: payload.teacher
    }),
    [teacherAbbreviationUpdate]: (state, payload) => ({
        ...state,
        teacher_abbreviation: payload.abbreviation
    }),
    [newUserSubjectLoad]: (state, payload) => ({
        ...state,
        ...payload,
        color: payload.color_id
    }),
    [newUserSubjectClear]: () => defaultState,
    [PURGE]: () => defaultState
}, defaultState);

export default newUserSubject;